import React from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
  Shape,
  Workflow,
  StateNode,
  StateTransition,
  createTransitionTarget
} from '@sierralabs/workflow';

export interface StateTransitionSelectorProps {
  shape: Shape;
  transition: StateTransition;
  workflow: Workflow;
  onChange?: (
    stateNode: StateNode | undefined,
    prevTarget: string,
    transition: StateTransition
  ) => void;
}

const StateTransitionSelector: React.FC<StateTransitionSelectorProps> = (
  props: StateTransitionSelectorProps
) => {
  const { shape, transition, workflow, onChange } = props;
  const options: string[] = workflow.getAllPaths();
  const transitionTarget: string = createTransitionTarget(
    shape,
    transition.target
  );
  // value is empty if it's not part of options
  const value: string = options.includes(transitionTarget)
    ? transitionTarget
    : '';
  return (
    <Autocomplete
      disableClearable
      className='field'
      {...{ value, options }}
      onChange={(_event: React.ChangeEvent<{}>, value: string | null) => {
        transition.target = value || '';
        const stateNode: StateNode | undefined = !value
          ? undefined
          : workflow.pathMap.get(value);
        onChange?.(stateNode, transitionTarget, transition);
      }}
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          size='small'
          variant='outlined'
          label='Transition'
        />
      )}
    />
  );
};

export default StateTransitionSelector;
